// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:22
import { AttachmentBase_abstract } from './../abstract/SagaBase/AttachmentBase_abstract';
export class AttachmentBase extends AttachmentBase_abstract {}
